import React from 'react';
import CadQuoteContainer from '../../containers/cadquote/CadQuoteContainer';

const CadQuotePage = () => {
  return <CadQuoteContainer />;
};

export default CadQuotePage;
